import { Injectable } from '@angular/core';
import { Params, Router } from '@angular/router';
import { RoutingService } from '../../services/Routing.service';
import { RouteId } from '../../enums/env/routes-id-enum';
import { RouteQueryParam } from '../constants/routes/route.query-param';

@Injectable({
  providedIn: "root",
})
export class NavigationService {
  
  constructor(private readonly router: Router) {}

  gotoExportRequestPage(routeState?: never) {
    this.router.navigate(
      [`/${RoutingService.getPathRoute(RouteId.EXPORT_REQUEST)}`],
      { state: routeState}
    );
  }

    gotoCreationExportRequestPage(queryParams: Params, routeState?: any) {
    return this.router.navigate(
      [`/${RoutingService.getPathRoute(RouteId.EXPORT_CREATION)}`],
      { state: routeState,
        queryParams: queryParams
      }
    );
  }

  gotoExportTemplatePage() {
    this.router.navigate([`/${RoutingService.getPathRoute(RouteId.EXPORT_TEMPLATE)}`]);
  }


}
